import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import VueI18n from 'vue-i18n';
import {
    messages
} from './components/common/i18n';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
// import './assets/css/theme-green/index.css'; // 浅绿色主题
import './assets/css/icon.css';
import './components/common/directives';
import 'babel-polyfill';
import Vuex from 'vuex';
import axios from 'axios';
// 引入全局组件
import noticeDialog from '../src/components/page/Notice.vue';
import indexPage from '../src/components/page/Dashboard.vue';
import bigName from '../src/components/page/BigName.vue';
import mySelect from '../src/components/component/select.vue'
import mySelectOptimized from '../src/components/component/selectOptimized.vue'
import mySelectVirtual from '../src/components/component/virtualSelect.vue'
import ReportTableChildren from '../src/components/component/ReportTableChildren.vue'
import ReportTableChildrenAll from '../src/components/component/ReportTableChildrenAll.vue'
import ImportDialog from '../src/components/component/ImportDialog.vue'
import imgUpload from '../src/components/component/imgUpload.vue'
import draggable from 'vuedraggable'
import { postExportExcel, getExportExcel, messageShow, multiplication2 } from '@/utils/multAdexportExcel.js';

import VueExcel from 'vue-element-excel';
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'
import VXETablePluginShortcutKey from 'vxe-table-plugin-shortcut-key'
import 'jquery'
import XEUtils from 'xe-utils'
import VXEUtils from 'vxe-utils'
// import Print from 'vue-print-nb'
import 'jquery'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import VXETablePluginElement from 'vxe-table-plugin-element'
import 'vxe-table-plugin-element/dist/style.css'
import preventReClick from './store/preventReClick' //防多次点击，重复提交

import '@/components/icon/font/iconfont.css'
import bus from '../src/components/common/bus';
import { MessageBox } from 'element-ui';
import Direction from 'vue-direction-key'
Vue.use(Direction)

import JsBarcode from "jsbarcode";

// 工具库
import './utils'

// 当前要用
import $timer from './utils/timer'

import html2canvas from 'html2canvas';
Vue.prototype.$html2canvas = html2canvas;
import validator from './utils/validator';
Vue.prototype.$vaildator = validator
NProgress.configure({
    easing: 'ease', // 动画方式    
    speed: 500, // 递增进度条的速度    
    showSpinner: false, // 是否显示加载ico    
    trickleSpeed: 200, // 自动递增间隔    
    minimum: 0.3 // 初始化时的最小百分比
})

import FingerprintJS from '@fingerprintjs/fingerprintjs';
Vue.prototype.$fingerprint = FingerprintJS.load();
// 引入echarts
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;
// router.beforeEach((to, from , next) => {
// 每次切换页面时，调用进度条
// NProgress.start();
// 这个一定要加，没有next()页面不会跳转的。这部分还不清楚的去翻一下官网就明白了         
// next();
// });

import Print from './print/print'
Vue.use(Print)
Vue.use(VXEUtils, XEUtils)
Vue.use(VXETable)

VXETable.use(VXETablePluginElement)
// VXETable.use(VXETablePluginShortcutKey, {
//     setting: {
//         'table.edit.leftTabMove': 'Shift + Enter',
//         'table.edit.rightTabMove': 'Enter',
//         'table.cell.downMove': 'Tab',
//     } // 将 Tab 键的按键值修改为回车键
// });


Vue.use(VueExcel);
// Vue.use(Blob);
// Vue.use(Export2Excel);

Vue.prototype.$axios = axios
Vue.prototype.$postExportExcel = postExportExcel
Vue.prototype.$multiplication2 = multiplication2
Vue.prototype.$getExportExcel = getExportExcel
Vue.prototype.$messageShow = messageShow

Vue.use(Vuex);
Vue.config.productionTip = false;
Vue.use(VueI18n);
Vue.use(ElementUI, {
    size: 'small'
});
// 全局通知，首页,公司名称组件
const noticeArr = {};
noticeArr.install = function (Vue) {
    Vue.component('noticeDialog', noticeDialog)
    Vue.component('indexPage', indexPage)
    Vue.component('bigName', bigName)
    Vue.component('mySelect', mySelect)
    Vue.component('mySelectOptimized', mySelectOptimized)
    Vue.component('mySelectVirtual', mySelectVirtual)
    Vue.component('imgUpload', imgUpload)
    Vue.component('draggable', draggable)
    Vue.component('ReportTableChildren', ReportTableChildren)
    Vue.component('ReportTableChildrenAll', ReportTableChildrenAll)
    Vue.component('ImportDialog', ImportDialog)

}
Vue.use(noticeArr);

const i18n = new VueI18n({
    locale: localStorage.getItem('language') || 'zh-CN', // 从本地存储读取或使用默认值
    messages
});
Vue.use(Vuex);
const state = { //要设置的全局访问的state对象
    showFooter: true,
    changableNum: 0,
    type: '开发版'
    //要设置的初始属性值
};
const getters = { //实时监听state值的变化(最新状态)
    isShow(state) { //承载变化的showFooter的值
        return state.showFooter
    },
    getChangedNum() { //承载变化的changebleNum的值
        return state.changableNum
    }
};
const mutations = {
    show(state) { //自定义改变state初始值的方法，这里面的参数除了state之外还可以再传额外的参数(变量或对象);
        state.showFooter = true;
    },
    hide(state) { //同上
        state.showFooter = false;
    },
    newNum(state, sum) { //同上，这里面的参数除了state之外还传了需要增加的值sum
        state.changableNum += sum;
    }
};
const actions = {
    hideFooter(context) { //自定义触发mutations里函数的方法，context与store 实例具有相同方法和属性
        context.commit('hide');
    },
    showFooter(context) { //同上注释
        context.commit('show');
    },
    getNewNum(context, num) { //同上注释，num为要变化的形参
        context.commit('newNum', num)
    }
};
const store = new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
    noticeDialog, //全局通知组件
    indexPage, //全局首页组件
    bigName, //全局名称（天宝软件）
    mySelectOptimized,
    mySelectVirtual,
    mySelect
});

export default store;

//使用钩子函数对路由进行权限跳转    
router.beforeEach((to, from, next) => {
    let tagsList = JSON.parse(sessionStorage.getItem('tagsList')) || []
    // document.title = `${to.meta.title}`;
    const role = localStorage.getItem('ms_username');
    let flag = navigator.userAgent.match( // match方法可在字符串内检索指定的值，
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
    // 刷新在线人数
    // $timer.js()
    if (to.path == '/login') {
        sessionStorage.removeItem('userToken');
        localStorage.removeItem('local_token');
    }
    if (!role && to.path !== '/login') {
        next('/login');
    }
    else {
        // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
        if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
            Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
                confirmButtonText: '确定'
            });
        } else {
            const isExist = tagsList.some(item => {
                return item.title === to.meta.title;
            })
            if (!isExist) {
                if (tagsList.length > 99) {
                    MessageBox.confirm('请关闭一个页面在打开', '提示', {
                        type: 'warning',
                        showCancelButton: false
                    }).then(res => {
                        next(from.path)
                    }).catch(() => {
                        next(from.path)
                    });
                } else {
                    next();
                }
            } else {
                next()
            }

        }
    }
});

new Vue({
    router,
    i18n,
    render: h => h(App)
}).$mount('#app');